import { Injectable } from '@angular/core';

import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';

declare const OSS: any;

@Injectable({ providedIn: 'root' })
export class AliOssClientService {
  constructor(private config: DynamicFormDesignerConfig) {}

  getClient(id: any): any {
    return new OSS.Wrapper(this.clientConfig(id));
  }

  clientConfig(id: any): OSSClientConfig {
    return this.config.getAliOssClientConfig(id);
  }
}

/**
 * @description ossclientéç½®ä¿¡æ¯
 *
 * @export
 */
export interface OSSClientConfig {
  region: string;
  accessKeySecret: string;
  accessKeyId: string;
  bucket: string;
}
